export default __webpack_public_path__ + "static/media/logo.3269db24.png";